import { animate, keyframes, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, Inject, Input, OnDestroy, TemplateRef, ViewEncapsulation } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MUI_APP_CONFIG, MuiModuleConfig } from '../../config';
import { MuiAnimationTiming } from '../../utility';
import { MuiHeroAreaService } from '../mui-hero-area.service';
import { MuiHeroContent } from '../mui-hero-content/mui-hero-content.component';
import { MuiHeroRightAppBarService } from '../mui-hero-right-app-bar/mui-hero-right-app-bar.service';


@Component({
  selector: 'mui-hero',
  templateUrl: './mui-hero.component.html',
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      :host {
        display: block;
        position: relative;
      }
    `
  ],
  animations: [
    trigger('stickyHeaderAnimation', [
      transition('false => true', [
        animate(
          MuiAnimationTiming.EASE_OUT,
          keyframes([style({ transform: 'translateY(-100%)' }), style({ transform: 'translateY(0)' })])
        )
      ])
    ])
  ]
})
export class MuiHeroComponent implements AfterViewInit, OnDestroy {
  @Input() pageTitle?: string;
  @Input() banner?: TemplateRef<any>;
  @Input() breadcrumbTemplate?: TemplateRef<any>;
  @Input() notificationArea?: TemplateRef<any>;
  @Input() mainMenuService: any;

  content: MuiHeroContent | null = null;
  rightAppBar?: TemplateRef<any>;
  sticky$: Observable<boolean>;

  private destroy$ = new Subject<void>();

  constructor(
    private heroAreaService: MuiHeroAreaService,
    private rightAppBarService: MuiHeroRightAppBarService,
    @Inject(MUI_APP_CONFIG) readonly routingOptions: MuiModuleConfig
  ) {
    this.sticky$ = this.heroAreaService.scrolled$;

    // This for some reason needs to be manually subscribed to work on app load
    this.heroAreaService.heroContent$.pipe(takeUntil(this.destroy$)).subscribe((c) => (this.content = c));
    // This for some reason needs to be manually subscribed to work on app load
    this.rightAppBarService.rightAppBarContent$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (content) => {
        if (!content) {
          return;
        }

        this.rightAppBar = content.rightAppBar;
      }
    });
  }

  ngAfterViewInit(): void {
    this.heroAreaService.scrolledThreshold = 60;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getBgImg(content: MuiHeroContent | null): string | null {
    if (content && content.background && content.background.url) {
      return `url(${content.background.url})`;
    } else {
      return null;
    }
  }

  getBgImgClass(content: MuiHeroContent | null): string {
    if (content && content.background && content.background.class) {
      return content.background.class;
    } else {
      return '';
    }
  }

  toggleMenu(): void {
    this.mainMenuService?.toggleMobileOpen();
  }

  getCollapsedstate(): Observable<boolean> {
    return this.mainMenuService.collapsed$;
  }
}
